import request from '@/plugins/request';

/**
 * 登录
 * @param data.loginName 登录名
 * @param data.password 密码
 * @returns {*}
 */
export function AccountLogin(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  });
}

/**
 * 注册
 * @param data.mobile 手机号
 * @param data.email 邮箱
 * @param data.userName 用户名
 * @param data.nickName 姓名
 * @param data.password 密码
 * @param data.validCode 验证码
 * @param data.remark 备注
 * @returns {*}
 */
export function AccountRegister(data) {
  return request({
    url: '/register',
    method: 'post',
    data: data
  });
}
export function getLoginUser() {
  return request({
    url: '/getLoginUser',
    method: 'post'
  });
}
export function updateUserInfo(data) {
  return request({
    url: '/system/user/updateUserInfo',
    method: 'post',
    data: data
  });
}
export function AccountLogout() {
  return request({
    url: '/logout',
    method: 'post'
  });
}